import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column pe-0 pe-sm-10" }
const _hoisted_2 = { class: "mb-1" }
const _hoisted_3 = { class: "fs-6 fw-bold" }
const _hoisted_4 = { class: "me-2" }
const _hoisted_5 = { class: "fs-6 fw-bold" }
const _hoisted_6 = { class: "pt-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto",
  "data-bs-dismiss": "alert"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-1 text-warning" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["alert bg-light-warning border border-warning d-flex flex-column flex-sm-row w-100 p-5", _ctx.dismiss ? 'alert-dismissible' : ''])
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["text-warning me-4 mb-5 mb-sm-0 fs-1", _ctx.alertIcon])
    }, null, 2),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.alertTitle), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("small", _hoisted_4, "By: " + _toDisplayString(_ctx.alertUser), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("small", null, _toDisplayString(_ctx.alertTime), 1)
      ]),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.alertDescription), 1)
    ]),
    _hoisted_7
  ], 2))
}